import React, { useRef, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { LoaderIcon } from '../../Icons';
import { MessageBubble } from './MessageBubble';
import { Messages } from '../../../../Models/Message';


interface MessageListProps {
  msgs: Messages[];
  loading: boolean;
  err: string | null;
  isMine: (m: Messages) => boolean;
  timeAgo: (date: string) => string;
}

export const MessageList: React.FC<MessageListProps> = ({ 
  msgs, 
  loading, 
  err, 
  isMine, 
  timeAgo 
}) => {
  const scrollAnchorRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    scrollAnchorRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [msgs]);

  if (loading && msgs.length === 0) {
    return (
      <div className="d-flex align-items-center gap-2">
        <LoaderIcon width={16} className="" />
        <span>Loading messages…</span>
      </div>
    );
  }

  if (err && msgs.length === 0) return <Alert variant="danger" className="mb-0">{err}</Alert>;
  if (msgs.length === 0) return <div className="text-muted">No messages yet.</div>;

  return (
    <div className="d-flex flex-column gap-3">
      {msgs.map((m, i) => (
        <MessageBubble
          key={m.id ?? `${m.authorUserId}-${m.createdAt}-${i}`}
          message={m}
          isMine={isMine(m)}
          timeAgo={timeAgo}
        />
      ))}
      <div ref={scrollAnchorRef} />
    </div>
  );
};

